const trustIconFigcaption = document.querySelector(
  ".product-detail__trust-icons figure"
);

const initializeClickyboxes = () => {
  const variantLinks = document.querySelectorAll(".clickyboxes a");
  if (variantLinks.length === 0) return; // Salir si no hay elementos clickyboxes

  // Función para actualizar la visibilidad del `figcaption`
  const updateVisibility = (isUnavailable) => {
    if (trustIconFigcaption) {
      trustIconFigcaption.style.display = isUnavailable ? "none" : "flex";
    }
  };

  // Añade eventos a cada variante
  variantLinks.forEach((link) => {
    link.addEventListener("click", function (e) {

      // Verifica si la variante seleccionada tiene la clase 'unavailable'
      const isUnavailable = this.classList.contains("unavailable");
      updateVisibility(isUnavailable);
    });
  });

  // Actualiza la visibilidad al cargar la página según la variante activa
  const activeLink = document.querySelector(".clickyboxes a.active");
  if (activeLink) {
    const isUnavailable = activeLink.classList.contains("unavailable");
    updateVisibility(isUnavailable);
  }
};

// Usa setInterval para esperar a que el contenido esté disponible
const interval = setInterval(() => {
  if (document.querySelector(".clickyboxes a")) {
    clearInterval(interval); // Detén el intervalo una vez que el contenido esté disponible
    initializeClickyboxes();
  }
}, 100); // Comprueba cada 100 ms

const container = document.querySelector(".product-detail__form__description");
const htmlContent = container.innerHTML;

// Encontrar la posición de "Model"
const modelIndex = htmlContent.indexOf("Model");
let shouldApplyStyles = false; // Variable para determinar si aplicamos estilos

if (modelIndex !== -1) {
  // Extraer el texto desde "Model"
  const extracted = htmlContent.slice(modelIndex);
  const closingTagIndex = extracted.indexOf("</p>") + 4;
  const modelContent = `<p>${extracted.slice(0, closingTagIndex)}</p>`;

  // Extraer el texto antes de "Model"
  const textBeforeModel = htmlContent.slice(0, modelIndex).trim();

  // Seleccionar el campo rich_text_field
  const richTextField = document.querySelector(".metafield-rich_text_field");

  if (richTextField) {
    // Conservar el contenido HTML existente y añadir el nuevo texto
    richTextField.innerHTML = `${textBeforeModel} ${richTextField.innerHTML}`;
  } else {
    console.error(
      "El campo .metafield-rich_text_field no se encontró en el documento."
    );
  }

  // Actualizar el contenedor original con el contenido modificado
  container.innerHTML = modelContent;

  shouldApplyStyles = true; // Marcamos que podemos aplicar estilos
} else {
  console.log('No se encontró la palabra "Model" en el contenido.');
}

// Solo aplica estilos si se encontró "Model" en la descripción
if (shouldApplyStyles) {
  const observer = new MutationObserver((mutationsList, observer) => {
    const usizyAdviser = document.querySelector("usizy-adviser");

    if (usizyAdviser) {
      const shadowRoot = usizyAdviser.shadowRoot;
      if (shadowRoot) {
        const style = document.createElement("style");
        style.textContent = `
                        @media only screen and (max-width: 1438px) {
                            #info-window {
                                left: -40px !important;
                            }
                        }
                        @media only screen and (max-width: 450px) {
                            #info-window {
                                left: -90px !important;
                            }
                            svg.tag_image {
                                height: 20px !important;
                                margin-right: 4px !important;
                            }
                            span#size-text {
                                font-size: 14px;
                            }
                        }
                    
                        svg.tag_image {
                            height: 25px;
                            fill: black;
                            background: transparent;
                            border: 0px;
                        }
                        span#size-text {
                            text-decoration: underline;
                        }
                    `;
        shadowRoot.appendChild(style);

        // Detenemos el observer después de aplicar el estilo
        observer.disconnect();
      }
    }
  });

  // Configuración para observar cambios en el DOM
  observer.observe(document.body, {
    childList: true, // Observar la adición de nodos
    subtree: true, // Observar todo el DOM
  });
}

/* Shoes Size-selector */

document.addEventListener("DOMContentLoaded", () => {
  // Cambiar entre regiones
  document.querySelectorAll(".size-label").forEach((button) => {
    button.addEventListener("click", () => {
      const region = button.dataset.region;

      // Actualizar botones activos
      document.querySelectorAll(".size-label").forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      // Actualizar visualización de opciones
      document.querySelectorAll(".size-region-option").forEach((option) => {
        const displayValue = option.dataset[region];
        const button = option.querySelector("button");

        button.style.display = "block";
        button.textContent = displayValue;
        button.dataset.region = region;

        // Ocultar otros grupos
        document
          .querySelectorAll(`.size-region-option:not([data-${region}]) button`)
          .forEach((btn) => {
            btn.style.display = "none";
          });
      });

      // Actualizar input con la talla regional activa (Al cambiar de región)
      const variantId = document.querySelector('select[name="id"]')?.value;
      const defaultOption = document.querySelector(`.size-region-option[data-variant-id="${variantId}"]`);
      const regionalSize = defaultOption?.dataset[region];
      const hiddenInput = document.querySelector("#regional-size-prop");

        if (hiddenInput && regionalSize) {
          const regionMap = {
            eu: "EU",
            usw: "US WOMEN",
            usm: "US MEN",
            uk: "UK",
          };
          const regionLabel =
            regionMap[region.toLowerCase()] || region.toUpperCase();
          hiddenInput.value = `${regionalSize} ${regionLabel}`;
        }
    });
  });

  // Manejar selección de talla
  document.querySelectorAll(".size-option").forEach((option) => {
    option.addEventListener("click", (e) => {
      const region = document.querySelector(".size-label.active").dataset.region.toUpperCase();
      const selectedSize = e.target.textContent.trim(); // Ej: "6.5"
      const optionContainer = e.target.closest(".size-region-option");
      const variantId = optionContainer.dataset.variantId;

      // Actualizar selector original
      const selector = document.querySelector(`select[name="id"] option[value="${variantId}"]`);
      if (selector) {
        selector.selected = true;
        selector.closest("select").dispatchEvent(new Event("change", { bubbles: true }));
      }

      // Marcar visualmente la opción seleccionada
      document.querySelectorAll(".size-option").forEach((opt) => opt.classList.remove("selected"));
      e.target.classList.add("selected");

      // Añadir lógica para unavailable
      if (optionContainer.dataset.available === "false") {
        e.target.classList.add("unavailable");
      } else {
        e.target.classList.remove("unavailable");
      }

      // Actualizar input
      const hiddenInput = document.querySelector("#regional-size-prop");
      if (hiddenInput) {
        const regionMap = {
          eu: "EU",
          usw: "US Woman",
          usm: "US Man",
          uk: "UK",
        };
        const regionLabel =
          regionMap[region.toLowerCase()] || region.toUpperCase();
        hiddenInput.value = `${selectedSize} ${regionLabel}`;
      }

      // Actualizar URL
      if (window.history?.replaceState) {
        const newUrl = new URL(window.location);
        newUrl.searchParams.set("variant", variantId);
        window.history.replaceState({}, "", newUrl);
      }
    });
  });

  // Inicializar input con talla regional por defecto
  const region = document.querySelector(".size-label.active")?.dataset.region?.toUpperCase() || "EU";
  const variantId = document.querySelector('select[name="id"]')?.value;
  const defaultOption = document.querySelector(`.size-region-option[data-variant-id="${variantId}"]`);
  const regionalSize = defaultOption?.dataset[region.toLowerCase()];
  const hiddenInput = document.querySelector("#regional-size-prop");

  if (hiddenInput && regionalSize) {
    const regionMap = {
      eu: "EU",
      usw: "US Woman",
      usm: "US Man",
      uk: "UK",
    };
    const regionLabel = regionMap[region.toLowerCase()] || region.toUpperCase();
    hiddenInput.value = `${regionalSize} ${regionLabel}`;
  }

  // Crear y posicionar la línea de hover
  const sizeGroups = document.querySelectorAll(".size-group");
  sizeGroups.forEach((group) => {
    const hoverLine = document.createElement("div");
    hoverLine.className = "cc-hover-line-custom";
    group.appendChild(hoverLine);

    // Actualizar posición al hover
    const buttons = group.querySelectorAll(".size-option:not(.unavailable)");
    buttons.forEach((button) => {
      button.addEventListener("mouseenter", () => {
        if (!button.classList.contains("selected")) {
          updateHoverLinePosition(button, hoverLine);
        }
      });

      button.addEventListener("mouseleave", () => {
        const selected = group.querySelector(".size-option.selected");
        if (selected) {
          updateHoverLinePosition(selected, hoverLine);
        } else {
          hoverLine.style.width = "0";
        }
      });
    });

    // Posición inicial si hay una talla seleccionada
    const selectedBtn = group.querySelector(".size-option.selected");
    if (selectedBtn) {
      updateHoverLinePosition(selectedBtn, hoverLine);
    }
  });

  function updateHoverLinePosition(button, lineElement) {
    const rect = button.getBoundingClientRect();
    const groupRect = button.closest(".size-group").getBoundingClientRect();

    lineElement.style.width = `${rect.width - 10}px`;
    lineElement.style.left = `${rect.left - groupRect.left + 5}px`;
    lineElement.style.top = `${rect.bottom - groupRect.top - 5}px`; // 5px de altura
  }

  // Actualizar en resize
  window.addEventListener("resize", () => {
    document.querySelectorAll(".size-group").forEach((group) => {
      const selectedBtn = group.querySelector(".size-option.selected");
      const hoverLine = group.querySelector(".cc-hover-line-custom");
      if (selectedBtn && hoverLine) {
        updateHoverLinePosition(selectedBtn, hoverLine);
      }
    });
  });
});